import { Suspense } from "react";
import { modalMapper } from "./index";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { modalActions } from "redux/slices/modal";
import CircleLoader from "components/atoms/CircleLoader";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import { useAppDispatch, useAppSelector } from "redux/hooks";

export default function AppModal() {
	const dispatch = useAppDispatch();
	const type = useAppSelector((state) => state.modal.type);
	const open = useAppSelector((state) => state.modal.open);
	const width = useAppSelector((state) => state.modal.width);
	const loading = useAppSelector((state) => state.modal.loading);

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick")
					dispatch(modalActions.closeModal());
			}}
			sx={{
				padding: "24px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backdropFilter: "blur(4px)",
			}}
		>
			<Box
				className="app-modal-body"
				sx={{
					p: 4,
					width: "100%",
					maxWidth: width,
					maxHeight: "90vh",
					overflowY: "auto",
					bgcolor: "background.paper",
					borderRadius: "20px",
					border: "1px solid rgba(82, 10, 118, 0.08)",
					boxShadow: "0 24px 48px rgba(0, 0, 0, 0.12), 0 8px 24px rgba(82, 10, 118, 0.08)",
					position: "relative",
					"&::-webkit-scrollbar": { width: 8 },
					"&::-webkit-scrollbar-thumb": {
						backgroundColor: "rgba(82, 10, 118, 0.2)",
						borderRadius: 4,
					},
				}}
			>
				<ErrorBoundary>
					<div style={{ minHeight: "80px", position: "relative", width: "100%" }}>
						<CloseIcon
							sx={{
								position: "absolute",
								top: -12,
								right: -12,
								cursor: "pointer",
								fontSize: 28,
								color: "#94a3b8",
								bgcolor: "#fff",
								borderRadius: "50%",
								boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
								zIndex: 1,
								"&:hover": { color: "#520A76", bgcolor: "rgba(82,10,118,0.06)" },
							}}
							onClick={() => dispatch(modalActions.closeModal())}
						/>
						{loading && (
							<Box
								sx={{
									position: "absolute",
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									zIndex: 10,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									bgcolor: "rgba(255,255,255,0.85)",
									borderRadius: "20px",
								}}
							>
								<CircleLoader />
							</Box>
						)}

						<Suspense fallback={<CircleLoader />}>
							{type && modalMapper[type]}
						</Suspense>
					</div>
				</ErrorBoundary>
			</Box>
		</Modal>
	);
}
